import { Sprout, Sun, Moon, LogOut } from "lucide-react";

/**
 * MobileTopBar — brand + theme toggle + admin chip + logout, pinned to
 * the top of mobile viewports (<lg). Primary navigation lives in
 * <MobileBottomNav/>; this row exists purely for brand identity,
 * quick theme swap, and sign-out reachability.
 */
export default function MobileTopBar({ user, isAdmin, theme, onToggleTheme, onLogout }) {
  return (
    <div className="lg:hidden fixed top-0 inset-x-0 z-20 border-b border-[var(--border-default)] bg-[var(--bg-primary)]/95 backdrop-blur">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="h-7 w-7 rounded bg-[var(--accent-primary)] flex items-center justify-center">
            <Sprout className="text-white" size={14} />
          </div>
          <div className="font-medium text-sm" style={{ fontFamily: "var(--font-heading)" }}>
            Finance Optimizer
          </div>
          {isAdmin && (
            <span
              className="ml-1 text-[9px] font-semibold tracking-[0.14em] uppercase px-1.5 py-0.5 rounded"
              style={{ background: "#E09E50", color: "white" }}
              data-testid="mobile-admin-chip"
            >
              Admin
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onToggleTheme}
            data-testid="mobile-theme-toggle"
            title={theme === "dark" ? "Switch to Daylight" : "Switch to Moonlit"}
            aria-label="Toggle theme"
            className="h-8 w-8 rounded-lg border border-[var(--border-default)] text-[var(--text-secondary)] hover:text-[var(--accent-primary)] hover:border-[var(--accent-primary)] transition-colors flex items-center justify-center"
          >
            {theme === "dark" ? <Sun size={14} /> : <Moon size={14} />}
          </button>
          <button onClick={onLogout} className="btn-danger-ghost" data-testid="mobile-logout" aria-label="Sign out">
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
